import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {EditService} from '../shared/services/editService/edit.service';
import {SportTypesService} from '../shared/services/databaseServices/sportTypes/sport-types.service';
import {FormBuilder, Validators} from '@angular/forms';
import {Category} from '../shared/classes/Category';
import {SportType} from '../shared/classes/SportType';
import {faSave, faTrash} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-sport-type-detail',
  templateUrl: './sport-type-detail.component.html',
  styleUrls: ['./sport-type-detail.component.css']
})
export class SportTypeDetailComponent implements OnInit {

  private static NEW = 'new';

  id;
  isNew;
  faSave = faSave;
  faTrash = faTrash;
  catName = undefined;
    edit = false;

  categories: Category[] = undefined;
  sportType: SportType = undefined;

  displayedColumns: string[] = ['name', 'ageFrom', 'ageTo'];

  header = [
    {
      defName: 'name',
      translation: 'settingPage.sportType.nameCat',
      elem: 'name'
    },
    {
      defName: 'ageFrom',
      translation: 'settingPage.sportType.ageFrom',
      elem: 'ageFrom'
    },
    {
      defName: 'ageTo',
      translation: 'settingPage.sportType.ageTo',
      elem: 'ageTo'
    }
  ];

  sportTypeForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    icon: ['', []]
  });

  ageCatForm = this.formBuilder.group({
    name: ['', [Validators.required]],
    ageFrom: ['', [Validators.required]],
    ageTo: ['', [Validators.required]]
  });

  constructor(private activadRoute: ActivatedRoute,
              private router: Router,
              private editService: EditService,
              private sportTypesService: SportTypesService,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.id = this.activadRoute.snapshot.paramMap.get('id');
    this.isNew = this.id ===  SportTypeDetailComponent.NEW;
    if(this.isNew){
      this.sportType = new SportType();;
      this.sportType.category = [];
    } else {
      this.sportTypesService.getOneSportType(this.id).then( data => {
       this.sportType = new SportType();
       this.sportType.id = data.id;
       this.sportType.type = data.data().type;
       this.sportType.category = data.data().category.map ( item => {
          const category: Category = {
            name: item.name,
            short: item.short === undefined ? '' : item.short,
            ageFrom: item.ageFrom,
            ageTo: item.ageTo,
            available: false
          };
          return category;
       });

       this.sportTypeForm.patchValue({
         name: this.sportType.type
       });
      });
    }
  }

  isEdit(){
    return this.editService.editable;
  }

  create(){
    this.sportType.type = this.sportTypeForm.get('name').value;
    const id = this.id === undefined ? this.sportType.type : this.id;
    this.sportTypesService.createSport(id, this.sportType).then( () => {
      this.router.navigate(['/admin/settings/sportType']);
    }).catch( err => {
      console.dir(err);
    });
  }

  remove(id){
    this.sportTypesService.deleteSport(id).then( () => {
      this.router.navigate(['/admin/settings/sportType']);
    }).catch( err => {
      console.dir(err);
    });
  }

  createCat() {
    const cat: Category = new Category();
    cat.name = this.ageCatForm.get('name').value;
    cat.ageFrom = this.ageCatForm.get('ageFrom').value;
    cat.ageTo = this.ageCatForm.get('ageTo').value;

    if (this.catName !== undefined) {
      this.sportType.category = this.sportType.category.filter( item => item.name !== this.catName );
    }

    this.sportType.category.push(cat);
    this.ageCatForm.reset();
    this.edit = false;
  }

  removeCat() {
    this.sportType.category = this.sportType.category.filter( item => item.name !== this.catName);
    this.catName = undefined;
    this.ageCatForm.reset();
  }

  isExist() {
    const name = this.ageCatForm.get('name').value;
    return this.sportType.category.map(item => item.name).indexOf(name) === -1 || this.edit;
  }

  editCat(item) {
    this.catName = item.name;
    this.edit = true;
    this.ageCatForm.patchValue({
      name: item.name,
      ageFrom: item.ageFrom,
      ageTo: item.ageTo
    });
  }

}
